<template>
  <review-single-select
    v-model="maternityFriendly"
    label="Was this item maternity friendly?"
    :options="maternityOptions"
    :validations="validations"/>
</template>

<script>
import ReviewSingleSelect from './ReviewSingleSelect'

export default {
  name: 'ReviewItemMaternityFriendly',
  components: { ReviewSingleSelect },
  model: {
    prop: 'review',
    event: 'change'
  },
  props: {
    review: {
      type: Object,
      required: true
    },
    validations: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      maternityOptions: [
        {
          text: 'Yes',
          value: 'true'
        },
        {
          text: 'No',
          value: 'false'
        }
      ]
    }
  },
  computed: {
    maternityFriendly: {
      get () {
        return this.review?.maternityFriendly?.toString()
      },
      set (value) {
        this.$emit('change', { ...this.review, maternityFriendly: value === 'true' })
      }
    }
  }
}
</script>
